import React, { useMemo, useRef, useState } from 'react'
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import DOMPurify from "dompurify";

const Accordion = ({ title, answer, isOpen }: { title: string, answer: string, isOpen: boolean }) => {
    const [open, setOpen] = useState<boolean>(isOpen);
    const contentRef = useRef<HTMLDivElement>(null);

    const cleanHTML = useMemo(() => {
        return DOMPurify.sanitize(answer, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'b', 'i', 'ul', 'ol', 'li', 'a'],
            ALLOWED_ATTR: ['href', 'target', 'rel'],
            ADD_ATTR: ['target']
        });
    }, [answer]);

    return (
        <div className={`flex flex-col border rounded-md w-full transition-colors duration-300 ease-in-out ${open ? 'bg-brand-green-10/15 border-brand-green-20' : 'bg-brand-green-10/5 border-brand-green-15'} hover:border hover:border-brand-green-20 hover:bg-brand-green-10/15`}>
            <button
                className='flex justify-between items-center w-full p-4'
                onClick={() => setOpen(!open)}
            >
                <p className='w-full text-left text-tmedium md:text-hsmall text-brand-green-20'>
                    {title}
                </p>
                <div className='!w-[1.5rem] !h-[1.5rem] flex items-center justify-center text-brand-green-20'>
                    {open ? <MdArrowDropUp size={18}/> : <MdArrowDropDown size={18}/>}
                </div>
            </button>

            <div
                ref={contentRef}
                style={{
                    maxHeight: open ? (contentRef.current?.scrollHeight ?? 9999) : 0,
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease-in-out',
                }}
            >
                <div
                    className='px-4 pb-4 b-medium text-system-light-100 space-y-2 text-bmedium
                        [&_a]:text-secondary-30 [&_a]:underline [&_a]:transition-colors [&_a:hover]:text-secondary-50'
                    dangerouslySetInnerHTML={{ __html: cleanHTML }}
                />
            </div>
        </div>
    );
}

export default Accordion;